import React from "react";
import ProfilePic from "../Assets/monmarche.png";
import { AiFillStar } from "react-icons/ai";

const Testimonial = () => {
  return (
    <div className="work-section-wrapper">
      <div className="work-section-top">
        <p className="primary-subheading">Nos Équipe</p>
        <h1 className="primary-heading">Équipe de Monmarche</h1>
        <p className="primary-text">
        Merci d'utiliser l'application Monmarche ! Nous attachons 
        une grande importance à la protection de votre vie privée et à la sécurité de vos données personnelles. 
        </p>
      </div>
      <div className="testimonial-section-bottom">
        <img src={ProfilePic} alt="" />
        <p>
        Chez Monmarche, nous nous efforçons de simplifier votre expérience de shopping en ligne, 
        en vous offrant un accès pratique à une vaste sélection de produits alimentaires de qualité, 
        directement depuis le confort de votre foyer. Que ce soit pour des baptêmes, 
        des mariages ou d'autres événements spéciaux, "Monmarche" est là pour vous fournir les produits 
        dont vous avez besoin pour célébrer ces moments uniques. 
        Parcourez notre sélection spéciale de produits pour vos événements
        et créez des souvenirs inoubliables avec "Monmarche".
        </p>
        <div className="testimonials-stars-container">
          <AiFillStar />
          <AiFillStar />
          <AiFillStar />
          <AiFillStar />
          <AiFillStar />
        </div>
        <h2>John Doe</h2>
      </div>
    </div>
  );
};

export default Testimonial;
